import { render, staticRenderFns } from "./HorarioForm.vue?vue&type=template&id=5a74dcf9"
import script from "./HorarioForm.vue?vue&type=script&lang=js"
export * from "./HorarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports